import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import type { NodeProps } from "reactflow";
import "../../styles/components/CustomNode.css";

interface ConditionNodeProps extends NodeProps {
  data: any;
}

const ConditionNode: React.FC<ConditionNodeProps> = ({ data, selected }) => {
  return (
    <div className={`custom-node node-condition ${selected ? "selected" : ""}`}>
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="node-handle"
        style={{ background: data.color || "#f59e0b" }}
      />

      <div className="node-header">
        <div className="node-header-icon">{data.icon || "🔍"}</div>
        <div className="node-header-title">{data.label || "Condition"}</div>
      </div>

      <div className="node-body">
        {data.nodeKey && (
          <div className="node-field">
            <div className="node-field-label">Type:</div>
            <div className="node-field-value">{data.nodeKey}</div>
          </div>
        )}
        {data.config?.field && (
          <div className="node-field">
            <div className="node-field-label">Field:</div>
            <div className="node-field-value">{data.config.field}</div>
          </div>
        )}
        {data.config?.operator && (
          <div className="node-field">
            <div className="node-field-label">Operator:</div>
            <div className="node-field-value">{data.config.operator}</div>
          </div>
        )}
        {data.config?.value !== undefined && (
          <div className="node-field">
            <div className="node-field-label">Value:</div>
            <div className="node-field-value">
              {String(data.config.value).substring(0, 20)}
              {String(data.config.value).length > 20 ? "..." : ""}
            </div>
          </div>
        )}
      </div>

      {/* Multiple output handles for branching (Yes/No) */}
      <Handle
        type="source"
        position={Position.Right}
        id="yes"
        className="node-handle"
        style={{ background: "#10b981", top: "35%" }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="no"
        className="node-handle"
        style={{ background: "#ef4444", top: "65%" }}
      />
    </div>
  );
};

export default memo(ConditionNode);
